'use strict';

const ContactUIStore = require('../stores/ContactUIStore');
const gaActions = require('./gaActions');
const transactionActions = require('./transactionActions');
const BunsenModal = require('bunsen/components/BunsenModal/BunsenModal-view');
const FavoriteDealerView = require('../../../global/modules/modalEmail/views/FavoriteDealerView');
const FavoritePageStore = require('../../../global/stores/FavoritePageStore');
const {TYPE_DEALER} = require('bunsen/models/identity/Favorite');
const User = require('bunsen/models/identity/User');
const {constants: authConstants} = require('../../../auth/authModalLoader').default;
const helpers = require('../helpers/contactHelpers');
const successModalCss = require('../styles/successModal.scss');
const chatUtils = require('../../../global/utils/social/chat');
const result = require('lodash.result');
const find = require('lodash.find');

const baseActions = module.exports = {
    initialLoad(actionContext, payload) {
        const {
            itemPk,
            sellerPk,
            preloadedSeller,
            linkLocation,
            sendToOmtOnSuccess,
            copyText,
            isNetPrice
        } = payload;
        actionContext.dispatch('contact:loading:start', { linkLocation, sendToOmtOnSuccess, itemPk });
        let gotItemOrSeller;
        if (itemPk) {
            gotItemOrSeller = helpers.loadItem(itemPk);
        } else if (sellerPk || preloadedSeller) {
            gotItemOrSeller = helpers.loadSeller(sellerPk, preloadedSeller);
        } else {
            throw new Error('payload must contain itemPk, preloadedSeller or sellerPk');
        }

        return gotItemOrSeller.then(options => {
            const { item, seller } = options;
            return helpers.loadUser().then(user => {
                return helpers.checkEmailOptIn({
                    itemId: result(item, 'id'),
                    dealerId: result(seller, 'id')
                }).then((isOptIn) => {
                    if (isOptIn) {
                        actionContext.dispatch('contact:showOptIn');
                    }
                    const params = Object.assign({}, options, { user, copyText, isNetPrice });
                    actionContext.dispatch('contact:loading:done', params);
                });
            });
        }, actionContext.dispatch.bind(actionContext, 'contact:serverError'));
    },

    closeModal(ac) {
        baseActions.fireChatEvent(ac);
        ac.dispatch('contact:modal:close');
    },

    openModal(ac, {modalId}) {
        ac.dispatch('contact:modal:open', {modalId});
    },

    toggleOffer(actionContext) {
        if (!actionContext.getStore(ContactUIStore).state.isOfferEnabled) {
            gaActions.eventOfferEnable(actionContext);
        }
        actionContext.dispatch('contact:offer:toggle');
    },

    toggleMessage(actionContext) {
        actionContext.dispatch('contact:message:toggle');
    },

    authSuccess(actionContext, payload) {
        const {userJSON, authAction} = payload;
        const user = new User(userJSON);
        actionContext.dispatch('contact:auth:done', { user });
        return {
            suppressSuccess: authAction === authConstants.REGISTER,
            user
        };
    },

    /**
     *  Opens the favorite dealer modal when successfully sending a message
     *
     *  @param payload.offerSent {boolean}
     *  @param payload.followDealerParams {object}
     *  @param payload.omtLinkParams {object}
     */
    submitSuccess(actionContext, payload) {
        actionContext.dispatch('contact:sending:done');
        baseActions.closeModal(actionContext);
        actionContext.dispatch('contact:reset');
        if (payload.suppressSuccess) {
            return;
        }
        const {
            offerSent,
            followDealerParams,
            omtLinkParams,
            componentContext
        } = payload;
        const state = actionContext.getStore(ContactUIStore).state;
        const dealerPk = state.seller.get('id');
        const content = document.createElement('div');
        const copyText = state.copyText;
        const modal = new BunsenModal({
            title: copyText.get('successHeader'),
            reuse: false,
            buttonAutoClose: true,
            classNames: {
                header: successModalCss.modalHeader,
                body: successModalCss.modalBody,
                content: successModalCss.modalContent
            },
            content
        });

        const isSaved = actionContext.getStore(FavoritePageStore).isSaved(TYPE_DEALER);

        new FavoriteDealerView({
            el: content,
            followDealerParams,
            omtLinkParams,
            dealerUrl: state.seller.get('sellerPreferences.urlLabel'),
            dealerName: state.seller.get('sellerProfile.company'),
            closeModal: modal.hide.bind(modal),
            openModal: modal.show.bind(modal),
            isArtSeller: state.seller.isArtSeller(),
            copyText,
            offerSent,
            dealerPk,
            componentContext,
            isSaved
        }).render();
    },

    setLowballOption(actionContext, payload) {
        const state = actionContext.getStore(ContactUIStore).state;
        const { lowballOptions } = state;
        const selectedLowballOption = find(lowballOptions, option => option.value === payload.value);
        if (selectedLowballOption.checked) {
            return;
        }
        actionContext.dispatch('contact:form:lowball:options:set', { selectedLowballOption });
        if (selectedLowballOption.value === 'other') {
            transactionActions.editOfferField(actionContext, { field: payload.field, value: '' });
        } else {
            transactionActions.editOfferField(actionContext, payload);
        }
    },

    fireChatEvent(actionContext) {
        const { chatSuccessEvent, chatAbandonEvent, formSubmitted } = actionContext.getStore(ContactUIStore).state;
        const trackEvent = chatUtils.track[formSubmitted ? chatSuccessEvent : chatAbandonEvent];
        if (trackEvent) {
            trackEvent();
        }
    }
};



// WEBPACK FOOTER //
// ./assets/js/contact/shared/actions/baseActions.es.js